import { ADMIN_URL,APP_BASE_URL } from '../../config/api';
// Use consistent base URLs for all endpoints
const RULES_URL = `${APP_BASE_URL}${ADMIN_URL}/rules`;
const ENTITIES_URL = `${APP_BASE_URL}${ADMIN_URL}/entities`;

export async function listRules(accountId) {
  const res = await fetch(`${ENTITIES_URL}/${accountId}/rules`);
  if (!res.ok) throw new Error("Failed to fetch rules");
  return res.json();
}

export async function createRule(payload) {
  console.log("createRule: ",payload)
  const res = await fetch(RULES_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("Failed to create rule");
  return res.json();
}

export async function updateRule(id, payload) {
  const res = await fetch(`${RULES_URL}/${id}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("Failed to update rule");
  return res.json();
}

export async function deleteRule(id) {
  const res = await fetch(`${RULES_URL}/${id}`, { method: "DELETE" });
  if (!res.ok) throw new Error("Failed to delete rule");
}

export async function createDefaultRules(accountId) {
  const res = await fetch(`${ENTITIES_URL}/${accountId}/default-rules`, {
    method: "POST",
    headers: { "Content-Type": "application/json" }
  });
  
  if (!res.ok) throw new Error("Failed to create default rules");
  return res.json();
}